import {
  PreferencesIcon
} from "./chunk-ZOYMHDWD.mjs";
export {
  PreferencesIcon
};
